import Index from "./Index.jsx";

const PROFILE_SETTING_WEB_PAGES = {
  INDEX: Index,
};
export default PROFILE_SETTING_WEB_PAGES;
